<template>
  <div class="purchase-page">
    <TopBanner />
    <div class="search-scroll-area">
      <div class="purchase-content">
        <div class="main-card">
          <!-- 产品汇总标题 -->
          <div class="section-title">
            <img class="title-icon" src="@/assets/image/purchase1.png" />
            <span style="margin-left: 8px">需求汇总</span>
          </div>

          <!-- 四张指标卡片 -->
          <div class="metric-cards">
            <!-- 验样中产品 -->
            <div class="metric-card card-purple" @click="jumpInfoManage('release')">
              <div style="display: flex; align-items: center; justify-content: space-between">
                <div class="card-number">{{ summaryCount.releaseCount || 0 }}</div>
                <img class="card-icon-img" src="@/assets/image/purchase6.png" />
              </div>

              <div class="card-label">验样中产品</div>
              <img class="card-arrow" src="@/assets/image/purchase7.png" />
            </div>

            <!-- 待发起订单 -->
            <div class="metric-card card-blue" @click="jumpInfoManage('wait_order')">
              <div style="display: flex; align-items: center; justify-content: space-between">
                <div class="card-number">{{ summaryCount.waitOrderCount || 0 }}</div>
                <img class="card-icon-img" src="@/assets/image/purchase5.png" />
              </div>
              <div class="card-label">待发起订单</div>
              <img class="card-arrow" src="@/assets/image/purchase7.png" />
            </div>

            <!-- 竞价中产品 -->
            <div class="metric-card card-green" @click="jumpInfoManage('bidding')">
              <div style="display: flex; align-items: center; justify-content: space-between">
                <div class="card-number">{{ summaryCount.biddingCount || 0 }}</div>
                <img class="card-icon-img" src="@/assets/image/purchase4.png" />
              </div>
              <div class="card-label">竞价中产品</div>
              <img class="card-arrow" src="@/assets/image/purchase7.png" />
            </div>

            <!-- 已交易中标 -->
            <div class="metric-card card-orange" @click="jumpInfoManage('completed')">
              <div style="display: flex; align-items: center; justify-content: space-between">
                <div class="card-number">{{ summaryCount.completedCount || 0 }}</div>
                <img class="card-icon-img" src="@/assets/image/purchase3.png" />
              </div>
              <div class="card-label">已交易中标</div>
              <img class="card-arrow" src="@/assets/image/purchase7.png" />
            </div>
          </div>

          <!-- 发布需求按钮 -->
          <div style="display: flex; justify-content: flex-end">
            <div class="publish-btn-wrapper" @click="submitRequirements">
              <img class="publish-btn" src="@/assets/image/purchase2.png" />
            </div>
          </div>
          <!-- 客服热线 -->
          <div class="service-section" :style="{ visibility: userInfo.accountLevel == '0' ? 'visible' : 'hidden' }">
            <img class="service-icon" src="@/assets/image/kehufuwu.png" />
            <div class="service-info">
              <div class="service-row">
                <span class="service-label-bold">客服热线：{{ customer_service_phone }}</span>
              </div>
              <div style="font-size: 20px; font-weight: 400; color: #333333; line-height: 24px">
                <span>客服服务时间：{{ customer_service_time }}</span>
              </div>
              <div style="font-weight: 400; font-size: 20px; color: #ff9318">联系客服购买会员即可发布需求信息</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog top="8vh" :append-to-body="true" :visible.sync="showServiceDialog" width="580px" :show-close="false" :close-on-click-modal="true" custom-class="kehufuwu">
      <CustomerService :showMemberHint="userInfo.accountLevel != '1'" @close="showServiceDialog = false" />
    </el-dialog>

    <!-- 产品需求发布弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showPublishDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleClosePublishDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showPublishDialog = false" />
        <h3 class="publish-title">产品需求发布</h3>
        <div class="publish-form">
          <!-- 产品名称 -->
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="publishForm.productName" placeholder="请输入" class="form-input" />
          </div>

          <!-- 产品分类 -->
          <div class="form-item">
            <span class="form-label">产品分类<i class="required-star">*</i></span>
            <!-- <el-select v-model="publishForm.productType" placeholder="请选择" class="form-select">
              <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select> -->
            <el-select v-model="publishForm.productTypeId" placeholder="请选择" class="form-select" @change="productTypeIdChange">
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>

          <!-- 联系方式 -->
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="publishForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>

          <!-- 验样时间 -->
          <div class="form-item">
            <span class="form-label">验样时间<i class="required-star">*</i></span>
            <el-date-picker value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" v-model="publishForm.verifyEndTime" type="datetime" placeholder="选择截止时间" class="form-date" />
          </div>

          <!-- 质量要求 -->
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">质量要求<i class="required-star">*</i></span>
            <el-input v-model="publishForm.qualityDemand" type="textarea" placeholder="请输入" class="form-textarea" :rows="4" />
          </div>

          <!-- 备注 -->
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="publishForm.productRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
          <!-- 产品图片 -->
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片<i class="required-star">*</i></span>
            <ImageUpload v-model="publishForm.productPicture" multiple :limit="5" dir="product" />
          </div>
          <!-- 发票图片 -->
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">发票图片</span>
            <div class="upload-row" style="align-items: flex-start">
              <ImageUpload v-model="publishForm.invoicePicture" :multiple="false" size="148px" dir="avatar" />
              <div>
                <el-button type="primary" :loading="isBtnLoading" @click="autoRecognize">识别</el-button>
                <!-- <span style="line-height: 40px; font-size: 18px; cursor: auto" class="auto-recognize" @click="autoRecognize">自动识别</span> -->
                <!-- <div v-if="publishForm?.invoicePicture.length != 0">
                  <div class="key-value-box">
                    <div class="m-key">抬头信息：</div>
                    <div class="m-value">{{ this.publishForm.invoiceTitle || "-" }}</div>
                  </div>
                  <div class="key-value-box">
                    <div class="m-key">税号：</div>
                    <div class="m-value">{{ this.publishForm.taxNumber || "-" }}</div>
                  </div>
                  <div class="key-value-box">
                    <div class="m-key">服务类型：</div>
                    <div class="m-value">{{ this.publishForm.serviceType || "-" }}</div>
                  </div>
                  <div class="key-value-box">
                    <div class="m-key">服务名称：</div>
                    <div class="m-value">{{ this.publishForm.serviceName || "-" }}</div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <!-- 发票类型 -->
          <div class="form-item">
            <span class="form-label">产品类别</span>
            <el-input v-model="publishForm.serviceType" class="form-input" />
          </div>
          <!-- 发票名称 -->
          <div class="form-item">
            <span class="form-label">产品名称</span>
            <el-input v-model="publishForm.serviceName" class="form-input" />
          </div>

          <!-- 税号 -->
          <!-- <div class="form-item">
            <span class="form-label">税号</span>
            <el-input v-model="publishForm.taxNumber" class="form-input" />
          </div> -->
          <!-- 抬头信息 -->
          <!-- <div class="form-item">
            <span class="form-label">抬头信息</span>
            <el-input v-model="publishForm.invoiceTitle" class="form-input" />
          </div> -->

          <div class="form-item">
            <span class="form-label">供应商</span>
            <el-input v-model="publishForm.supplierName" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">采购商</span>
            <el-input v-model="publishForm.purchaseName" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">单价</span>
            <el-input v-model="publishForm.unitPrice" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">数量</span>
            <el-input v-model="publishForm.number" class="form-input" />
          </div>
        </div>

        <!-- 确定发布按钮 -->
        <div style="text-align: center">
          <button class="publish-submit-btn" @click="handlePublishSubmit">确定发布</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";
import CustomerService from "@/components/CustomerService.vue";
import ImageUpload from "@/components/ImageUpload.vue";
import { publishDemand, getDemandSummary, invoiceOcr, getProductTypeList } from "@/api/demand";
import { getDictData } from "@/api";

export default {
  name: "Purchase",
  components: {
    TopBanner,
    CustomerService,
    ImageUpload,
  },
  data() {
    return {
      loading: false,
      showServiceDialog: false,
      showPublishDialog: false,
      customer_service_phone: localStorage.getItem("customer_service_phone"),
      customer_service_time: localStorage.getItem("customer_service_time"),
      summaryCount: {
        releaseCount: 0,
        waitOrderCount: 0,
        biddingCount: 0,
        completedCount: 0,
      },
      publishForm: {
        productName: "",
        productTypeId: "",
        productType: "",
        relationPhone: "",
        verifyEndTime: "",
        qualityDemand: "",
        productRemark: "",
        productPicture: [],
        invoicePicture: "",
        invoiceTitle: "", // 抬头信息
        taxNumber: "", // 税号
        serviceType: "", // 服务类型
        serviceName: "", // 服务名称
        supplierName: "", // 供应商
        purchaseName: "", // 采购商
        unitPrice: "", // 单价
        number: "", // 数量
        demandStatus: "release", //需求状态(draft=草稿,release=发布/验样阶段,wait_order=待发起订单,bidding=竞价阶段,repurchase_bidding=复购竞价,completed=已完成,close=关闭)
      },
      productTypes: [],
      userInfo: {
        userId: null,
        headPortrait: "",
        userName: "",
        enterpriseName: "",
        relationName: "",
        relationPhone: "",
        postName: "",
        role: "",
        wxNumber: "",
        mail: "",
        address: "",
        businessLicense: "",
      },
      productTypeList: [],
      isBtnLoading: false,
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userRes"));
    this.fetchDemandSummary();
    // this.fetchDict();
    this.getProductTypeListFun();
  },
  methods: {
    productTypeIdChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.publishForm.productType = item.typeName;
        }
      });
    },
    getProductTypeListFun() {
      getProductTypeList().then((res) => {
        this.productTypeList = res.rows;
      });
    },

    async fetchDemandSummary() {
      try {
        const res = await getDemandSummary();
        if (res.code === 200) {
          this.summaryCount = res.data || {};
        }
      } catch (error) {
        console.error("获取需求汇总失败：", error);
      }
    },
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
    /** 发票自动识别 */
    async autoRecognize() {
      const imageUrl = this.publishForm.invoicePicture;
      if (!imageUrl) {
        this.$message.warning("请先上传发票");
        return;
      }
      this.isBtnLoading = true;
      try {
        const res = await invoiceOcr({ imageUrl });
        if (res.code == 200) {
          const data = res.data || {};
          this.publishForm.invoiceTitle = data.invoiceTitle || "";
          this.publishForm.taxNumber = data.taxNumber || "";
          this.publishForm.serviceType = data.serviceType || "";
          this.publishForm.serviceName = data.serviceName || "";
          this.publishForm.supplierName = data.supplierName || "";
          this.publishForm.purchaseName = data.purchaseName || "";
          this.publishForm.unitPrice = data.unitPrice || "";
          this.publishForm.number = data.number || "";
          this.$message.success("识别成功");
          this.isBtnLoading = false;
        } else {
          this.$message.error(res.msg || res.message || "识别失败");
          this.isBtnLoading = false;
        }
      } catch (error) {
        console.error("发票识别失败：", error);
        this.$message.error(error.message || "识别失败");
        this.isBtnLoading = false;
      }
    },
    jumpInfoManage(route) {
      this.$router.push({
        name: "InfoManage",
        query: { route },
      });
    },

    submitRequirements() {
      if (this.userInfo.accountLevel == "1") {
        this.showPublishDialog = true;
      } else {
        // 未开通会员
        this.showServiceDialog = true;
      }
    },
    async handlePublishSubmit() {
      // 必填校验
      if (!this.publishForm.productName.trim()) {
        this.$message.warning("请输入产品名称");
        return;
      }
      if (!this.publishForm.productTypeId) {
        this.$message.warning("请选择产品分类");
        return;
      }
      if (!this.publishForm.relationPhone.trim()) {
        this.$message.warning("请输入联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.publishForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.publishForm.verifyEndTime) {
        this.$message.warning("请选择验样时间");
        return;
      }
      if (!this.publishForm.qualityDemand.trim()) {
        this.$message.warning("请输入质量要求");
        return;
      }
      if (this.publishForm.productPicture.length == 0) {
        this.$message.warning("请上传产品图片");
        return;
      }

      // 构造请求参数
      const params = {
        productName: this.publishForm.productName,
        productTypeId: this.publishForm.productTypeId,
        productType: this.publishForm.productType,
        relationPhone: this.publishForm.relationPhone,
        verifyEndTime: this.publishForm.verifyEndTime,
        qualityDemand: this.publishForm.qualityDemand,
        productRemark: this.publishForm.productRemark,
        productPicture: Array.isArray(this.publishForm.productPicture) ? this.publishForm.productPicture.join(",") : "",
        invoicePicture: this.publishForm.invoicePicture,
        demandStatus: this.publishForm.demandStatus,
        invoiceTitle: this.publishForm.invoiceTitle, // 发票抬头
        taxNumber: this.publishForm.taxNumber, // 税号
        serviceType: this.publishForm.serviceType, // 发票服务类型
        serviceName: this.publishForm.serviceName, // 发票服务名称
        supplierName: this.publishForm.supplierName, // 供应商
        purchaseName: this.publishForm.purchaseName, // 采购商
        unitPrice: this.publishForm.unitPrice, // 单价
        number: this.publishForm.number, // 数量
      };

      try {
        const res = await publishDemand(params);
        if (res.code === 200) {
          this.$message.success("需求发布成功");
          this.showPublishDialog = false;
          this.resetPublishForm();
          this.fetchDemandSummary();
        } else {
          this.$message.error(res.msg || res.message || "发布失败");
        }
      } catch (error) {
        this.$message.error(error.message || "发布失败，请稍后重试");
      }
    },
    handleClosePublishDialog() {
      this.showPublishDialog = false;
      this.resetPublishForm();
    },
    resetPublishForm() {
      this.publishForm = {
        productName: "",
        productTypeId: "",
        productType: "",
        relationPhone: "",
        verifyEndTime: "",
        qualityDemand: "",
        productRemark: "",
        productPicture: [],
        invoicePicture: "",
        invoiceTitle: "",
        taxNumber: "",
        serviceType: "",
        serviceName: "",
        demandStatus: "release",
      };
    },
  },
};
</script>

<style>
.kehufuwu {
  border-radius: 30px;
}
.kehufuwu .el-dialog__header {
  padding: 0;
}

.kehufuwu .el-dialog__body {
  padding: 0;
}

/* 引入产品需求发布弹窗公共样式 */
@import "~@/assets/css/publish-dialog.css";
</style>

<style scoped>
.purchase-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f0f4f8;
}

.search-scroll-area {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.purchase-content {
  padding: 14px 40px;
  display: flex;
  justify-content: center;
}

/* 主白卡容器 */
.main-card {
  width: 100%;
  max-width: 1200px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  padding: 130px 25px 110px 25px;
}

/* 产品汇总标题 */
.section-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
}

.title-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

/* 四张指标卡片 */
.metric-cards {
  display: flex;
  gap: 29px;
  margin-bottom: 148px;
  margin-top: 36px;
}

.metric-card {
  flex: 1;
  border-radius: 20px;
  padding: 13px 16px 21px 30px;
  position: relative;
  cursor: pointer;
  transition: box-shadow 0.3s, transform 0.3s;
}

.metric-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.metric-card.card-purple {
  border: 1px solid #d8e1fb;
  background: linear-gradient(0deg, #f5f6fd 0%, #ffffff 100%);
}

.metric-card.card-blue {
  border: 1px solid #a4e0f5;
  background: linear-gradient(0deg, #d1f3ff 0%, #ffffff 100%);
}

.metric-card.card-green {
  border: 1px solid #acf0da;
  background: linear-gradient(0deg, #e1f8f1 0%, #ffffff 100%);
}

.metric-card.card-orange {
  border: 1px solid #feddc9;
  background: linear-gradient(0deg, #fff3ec 0%, #ffffff 100%);
}

/* 卡片图标 */
.card-icon-img {
  width: 68px;
  height: 68px;
}

/* 数字 */
.card-number {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 800;
  font-size: 32px;
  color: #333333;
}

/* 标签 */
.card-label {
  margin-top: 32px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
}

/* 箭头 */
.card-arrow {
  width: 22px;
  height: 22px;
  margin-top: 23px;
}

/* 客服区域 */
.service-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 21px;
  margin-top: 50px;
}

/* 客服图标 */
.service-icon {
  width: 130px;
  height: 130px;
  flex-shrink: 0;
}

.service-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-row {
  font-size: 14px;
  color: #333333;
}

.service-label-bold {
  font-weight: 600;
  font-size: 28px;
  color: #333333;
}

/* 发布需求按钮 */
.publish-btn-wrapper {
  cursor: pointer;
  transition: transform 0.3s;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.publish-btn-wrapper:hover {
  transform: scale(1.05);
}

.publish-btn {
  width: 100%;
  height: 100%;
}
/* 发票 */
.key-value-box {
  display: flex;
}
.key-value-box .m-key {
  width: 90px;
  display: inline-block;
  text-align: right;
  line-height: normal;
}
.key-value-box .m-value {
  flex: 1;
}
</style>
